import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const get = (noteId: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_NOTE_DOCS_REQUEST });

  return api.eligibility.noteDocs.get(noteId)
    .then((res: any) => {

      dispatch({
        type: types.GET_NOTE_DOCS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_NOTE_DOCS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const deleteNote = (memberDocId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityNoteDocs.isDeleting) { return Promise.reject(); }

  dispatch({ type: types.DELETE_NOTE_DOC_REQUEST });

  return api.eligibility.noteDocs.delete(memberDocId)
    .then((res: any) => {

      dispatch({
        type: types.DELETE_NOTE_DOC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DELETE_NOTE_DOC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
